import React, { useState, useEffect } from "react";
import { DefaultButton, IconButton } from "@fluentui/react/lib/Button";
import { useId } from "@fluentui/react-hooks";
import { getTheme, mergeStyleSets, FontWeights, Modal } from "@fluentui/react";
import {
  ERROR_TYPE,
  WARNING_TYPE,
  INFO_TYPE,
  SERVER_WARNING_TYPE,
  SUCCESS_TYPE,
  DEFAULT_SUCCESS_MESSAGE,
  DEFAULT_SUCCESS_TITLE
} from "../../redux/constants/messageTypes";
import {
  DATA_LOAD_STATUS,
  CHECKIN_PROCESS_TYPE,
} from "../../redux/constants/metaData";
import { useMetadata } from "../../redux/hooks/useMetadata";
import { useCheckin } from "../../redux/hooks/useCheckin";
import { useTools } from "../../redux/hooks/useTools";
import { useTheme } from "../../theme/OAS365Theme";

import { toast } from "react-toastify";
import {
  ErrorToast,
  SuccessToast,
  toastConfig,
} from "../../components/common/ToastNotification";
import { getValidValue } from "../../functions/helperMethod";

export const SuccessToastBox = () => {
  const metadata = useMetadata();
  const { onSuccessMessageClose } = useTools();
  const successMessageInfo = metadata.successMessageInfo;
  const showSuccessMessage = metadata.showSuccessMessage;
  const titleId = useId("title");
  const themeConfig = useTheme();
  const theme = getTheme();

  const [moreDetails, setMoreDetails] = useState("Details");
  const [isMoreDetails, setIsMoreDetails] = useState(false);

  let title = successMessageInfo?.type;
  let toastTitle = successMessageInfo?.title;
  let message = successMessageInfo?.message;
  let errorMessage = successMessageInfo?.errorMessage;
  let headerBorder = "4px solid #C14646";

  useEffect(() => {
    if (showSuccessMessage && successMessageInfo?.type === SUCCESS_TYPE) {
      const toastId = `success-${toastTitle?.trim() ? toastTitle : title}-${
        typeof message === "string" ? message : "Success"
      }`;
      let successMessage = getValidValue(message, DEFAULT_SUCCESS_MESSAGE);
      let successTitle = getValidValue(toastTitle, DEFAULT_SUCCESS_TITLE);
      toast.success(
        <SuccessToast
          title={successTitle}
          description={successMessage}
        />,
        { ...toastConfig.success, toastId },
      );

      onSuccessMessageClose();
    }
  }, [showSuccessMessage, successMessageInfo]);

  if (
    successMessageInfo?.type === SUCCESS_TYPE
  ) {
    return null;
  }

  switch (title) {
    case WARNING_TYPE:
      headerBorder = "4px solid #ffcc00";
      break;
    case SERVER_WARNING_TYPE:
      headerBorder = "4px solid #ffcc00";
      title = message;
      message = errorMessage;
      break;
    case INFO_TYPE:
      headerBorder = "4px solid #107c10";
      break;
    default:
      headerBorder = "4px solid #a80000";
      break;
  }

  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      selectors: {
        ".ms-Modal-scrollableContent": {
          backgroundColor: themeConfig.colors.backgroundColor,
          color: themeConfig.colors.fontColor,
        },
      },
    },
    header: [
      theme.fonts.xLargePlus,
      {
        flex: "1 1 auto",
        borderTop: headerBorder,
        display: "flex",
        alignItems: "center",
        fontFamily: themeConfig.fonts.regular,
        fontWeight: FontWeights.semibold,
        fontSize: themeConfig.fontSizes.medium,
        padding: "12px 12px 14px 24px",
      },
    ],
    body: {
      flex: "4 4 auto",
      fontFamily: themeConfig.fonts.regular,
      padding: "0 24px 24px",
      overflowY: "hidden",
    },
  });

  // function clickOk() {
  //   setIsMoreDetails(false);
  //   onSuccessMessageClose();

  //   if (checkinProgresseType === CHECKIN_PROCESS_TYPE.checkin) {
  //     onCheckinDocumentProgress(DATA_LOAD_STATUS.completed);
  //   }
  // }

  // function getErrorMessage() {
  //   if (!errorMessage) return [];
  //   return typeof errorMessage === "string"
  //     ? errorMessage.split(/\r\n|\n|\r/gm)
  //     : [errorMessage];
  // }

  // function toggleDetails() {
  //   setIsMoreDetails(!isMoreDetails);
  //   setMoreDetails(isMoreDetails ? "Details" : "Hide Details");
  // }
  return <></>;
  // return (
  //   <Modal
  //     titleAriaId={titleId}
  //     isOpen={openMessageBox}
  //     isBlocking={false}
  //     containerClassName={contentStyles.container}
  //   >
  //     <div className={contentStyles.header}>
  //       <span id={titleId}>{title}</span>
  //       <IconButton
  //         styles={iconButtonStyles}
  //         iconProps={cancelIcon}
  //         ariaLabel="Close"
  //         onClick={clickOk}
  //       />
  //     </div>

  //     <div className={contentStyles.body}>
  //       <p style={{ maxWidth: 435 }}>
  //         {message}
  //         <br />
  //         {isMoreDetails && (
  //           <span style={{ fontSize: "small", color: "red" }}>
  //             {getErrorMessage().map((line, i) => (
  //               <div key={i}>{line}</div>
  //             ))}
  //           </span>
  //         )}
  //       </p>

  //       <div>
  //         {displayDetailsButton && getErrorMessage().length > 0 && (
  //           <DefaultButton
  //             style={{ float: "left", marginTop: 10 }}
  //             text={moreDetails}
  //             onClick={toggleDetails}
  //           />
  //         )}

  //         <DefaultButton
  //           style={{
  //             float: "right",
  //             marginTop: 10,
  //             color: themeConfig.colors.buttonTextColor,
  //             backgroundColor: themeConfig.colors.themeDarkColor,
  //             borderRadius: 25,
  //             fontFamily: themeConfig.fonts.regular,
  //             fontWeight: themeConfig.fontWeight.menuWeight,
  //           }}
  //           text="OK"
  //           onClick={clickOk}
  //         />
  //       </div>
  //     </div>
  //   </Modal>
  // );
};

const cancelIcon = { iconName: "Cancel" };

const iconButtonStyles = {
  root: {
    marginLeft: "auto",
    marginTop: 4,
    marginRight: 2,
  },
};

export default SuccessToastBox;
